import { createContext, useContext, useState, type ReactNode } from "react";
import type { BoardRepo } from "./repo";
import { SupabaseBoardRepo } from "./supabase-board-repo";

const BoardRepoContext = createContext<BoardRepo | null>(null);

/** Tests pass a FakeBoardRepo; the app gets the Supabase one. */
export function BoardRepoProvider({ repo, children }: { repo?: BoardRepo; children: ReactNode }) {
  const [value] = useState<BoardRepo>(() => repo ?? new SupabaseBoardRepo());
  return <BoardRepoContext.Provider value={value}>{children}</BoardRepoContext.Provider>;
}

export function useBoardRepo(): BoardRepo {
  const repo = useContext(BoardRepoContext);
  if (!repo) throw new Error("useBoardRepo must be used inside <BoardRepoProvider>");
  return repo;
}
